// extracted by mini-css-extract-plugin
module.exports = {"name":"CharacterCard_name__2vwML","icons":"CharacterCard_icons__3CPQt","icon":"CharacterCard_icon__3piz6"};